/** Registreert de Vandaag focus-hint op de lijst-play-knop (queue prioriteit 30). */
import { ONBOARDING_HINT_FOCUS } from '@/constants/onboardingHints';
import { ONBOARDING_HINT_QUEUE_PRIORITIES } from '@/features/onboarding/constants/onboardingHintQueue';
import { useRegisterOnboardingQueuedHint } from '@/features/onboarding/context/useRegisterOnboardingQueuedHint';
import { useFocusContext } from '@/features/tasks/context/FocusContextExport';
import { useFocusPlayHint } from '@/features/today/hooks/use-focus-play-hint';
import { useT } from '@/i18n/useT';

/**
 * @param {Object} params
 * @param {string | null | undefined} params.topActionableTaskId
 * @param {string | undefined} params.userId
 */
export function useTodayFocusListHint({ topActionableTaskId, userId }) {
  const t = useT();
  const { activeFocusTaskId } = useFocusContext();
  const playTargetVisible =
    Boolean(topActionableTaskId) && !activeFocusTaskId;
  const { showHint, dismissHint } = useFocusPlayHint({
    playTargetVisible,
    userId,
    activeFocusTaskId,
  });
  const focusHintBody = t(
    'onboarding.focusHint.body',
    'Start focus op de taak waar je nu aan begint.',
  );

  useRegisterOnboardingQueuedHint({
    id: ONBOARDING_HINT_FOCUS,
    priority: ONBOARDING_HINT_QUEUE_PRIORITIES[ONBOARDING_HINT_FOCUS],
    eligible: playTargetVisible,
    pending: showHint,
    body: focusHintBody,
    testId: 'focus-play-hint',
    onDismiss: dismissHint,
    dismissTabIndex: -1,
  });
}
